import React, { useState } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid'


export default function MapFooter(props) {

    const useStyles = makeStyles({

        root: {
            display:"flex",
            flexDirection:"row",
            /* width: props.width, */
            height:20,
            backgroundColor: '#FFFFFF',
            color: '#000',
            zindex: 100,
        },

      });

  const classes = useStyles();

  const [copyright] = useState(process.env.REACT_APP_MAP_COPYRIGHT + ' '+ new Date().getFullYear());
  //const [copyright] = useState(process.env.REACT_APP_MAP_COPYRIGHT + ' 12345');

  return (
    <div id='footer' className={classes.root}>
        <Grid container>
            <Grid item xs={5}></Grid>
            <Grid item xs={3}>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><Box p={1} fontSize={12}>{copyright}</Box></Grid>
        </Grid>
    </div>
  );
}